<app-card [loading]="(loading$ | async) ?? false">
  <div class="header" [formGroup]="filterForm">
    @if (!isFilterDialogOpen) {
      <div class="header only-desktop">
        <ng-container *ngTemplateOutlet="headerFilterFields" />
      </div>
    }

    <button
      type="button"
      class="button icon-button only-mobile"
      (click)="openFilterDialog()"
    >
      <app-icon name="ic_filter" />
      {{ "default.filter" | translate }}
    </button>

    <button type="button" class="button icon-button" (click)="toggleView()">
      @if (isListView) {
        <app-icon name="ic_list"></app-icon>
        {{ "default.view.list" | translate }}
      } @else {
        <app-icon name="ic_tiles"></app-icon>
        {{ "default.view.tiles" | translate }}
      }
    </button>
  </div>

  @if (!isFilterDialogOpen) {
    <div class="header only-desktop">
      <ng-container *ngTemplateOutlet="filterFields" />
    </div>
  }
  @if (isListView) {
    <div class="content grid grid-cols-devices">
      @for (device of pumpList$ | async; track device.id) {
        <app-device-item-card
          [device]="device"
          [disabled]="!(killSwitch$ | async)"
          (triggerDeviceAction)="onTriggerDeviceAction($event)"
        />
      } @empty {
        {{ "pumps.empty" | translate }}
      }
    </div>
  } @else {
    <div class="content">
      <table>
        <thead>
          <tr app-device-item-row [isHeader]="true"></tr>
        </thead>
        <tbody>
          @for (device of pumpList$ | async; track device.id) {
            <tr
              app-device-item-row
              [device]="device"
              [disabled]="!(killSwitch$ | async)"
              (toggleFavorite)="onToggleFavorite(device)"
              (delete)="onDeletePump($event)"
              (edit)="onEditPump($event)"
              (triggerDeviceAction)="onTriggerDeviceAction($event)"
            ></tr>
          } @empty {
            <tr>
              <td colspan="100%">
                {{ "pumps.empty" | translate }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
  <div class="footer">
    <app-pagination
      [pageSize]="filterForm.value.pageSize"
      [totalCount]="totalCount$ | async"
      [currentPage]="filterForm.value.page"
      (pageChange)="onChangePage($event)"
      [loading]="loading$ | async"
    />
  </div>

  <!-- Filter Templates -->
  <ng-template #headerFilterFields [formGroup]="filterForm">
    <app-input-wrapper [control]="filterForm.controls['searchTerm']">
      <app-icon name="ic_search" input-wrapper-icon-start />
      <input
        type="search"
        formControlName="searchTerm"
        [placeholder]="'default.search' | translate"
      />
    </app-input-wrapper>
    <app-input-wrapper isSelect [control]="filterForm.controls['sortOrder']">
      <app-icon name="ic_sort" input-wrapper-icon-start />
      <select formControlName="sortOrder">
        @for (sortOption of filterOptions.sortOrder; track sortOption.value) {
          <option [value]="sortOption.value">
            {{ sortOption.label | translate }}
          </option>
        }
      </select>
    </app-input-wrapper>
  </ng-template>

  <ng-template #filterFields>
    <div class="filter-fields flex gap-2" [formGroup]="filterForm">
      <div class="filter-group">
        <div class="flex wrap">
          <label class="filter-label only-mobile">{{
            "devices.filter.listScope.label" | translate
          }}</label>
          @for (
            listScopeOption of filterOptions.listScope;
            track listScopeOption.value
          ) {
            <app-input-wrapper [control]="filterForm.controls['listScope']">
              <input
                [id]="'listScope-' + listScopeOption.value"
                [value]="listScopeOption.value"
                type="radio"
                name="listScope"
                formControlName="listScope"
              />
              <label [for]="'listScope-' + listScopeOption.value">{{
                listScopeOption.label | translate
              }}</label>
            </app-input-wrapper>
          }
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #filterDialogFields>
    <div class="filter-fields flex gap-2" [formGroup]="filterForm">
      <ng-container *ngTemplateOutlet="headerFilterFields" />
      <ng-container *ngTemplateOutlet="filterFields" />
    </div>
  </ng-template>
</app-card>
